import React from "react";
import FormTitle from "../../atoms/FormTitle";
import ContentContainer from "../../atoms/ContentContainer";
import InputWrapper from "../../atoms/InputWrapper";
import ChevronRight from "../../atoms/icons/ChevronRight";
import InputItem from "../../atoms/InputItem";
const ClaimInformation = ({ onSubmit: handleSubmit, data, loading, }) => (React.createElement("form", { onSubmit: handleSubmit },
    React.createElement(ContentContainer, { hasFooterActions: true, hasNextButtonIconRight: true, loading: loading, buttonFullWidth: true, nextButtonIcon: React.createElement(ChevronRight, null), nextButtonText: "Volgende stap" },
        React.createElement(FormTitle, null, "Overtredinggegevens"),
        React.createElement(InputWrapper, null,
            React.createElement(InputItem, { type: "text", name: "license_plate", label: "Kenteken", disabled: loading, readOnly: true, value: data.licence_plate })),
        React.createElement(InputWrapper, null,
            React.createElement(InputItem, { type: "text", name: "place", label: "Plaats", disabled: loading, readOnly: true, value: data.offence_place + ", " + data.offence_municipality })),
        React.createElement(InputWrapper, null,
            React.createElement(InputItem, { type: "text", name: "date", label: "Datum", disabled: loading, readOnly: true, value: data.offence_date })))));
export default ClaimInformation;
